import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { scroller } from 'react-scroll';
import { getSubmittedFormData, LOGGER_ENDPOINT } from '../../../utils/api';
import { SpinnerPage } from '../../common/SpinnerPage/SpinnerPage';
import styles from './signing-page.module.less';
import { Action, RoutePath } from '../../../utils/types';
import { useGlobalContext } from '../../../context/GlobalContext';
import { remoteLogError } from '@gjensidige/gpf-js-utils/es6/logging/error-handler';
import { scenarioSteps, trackScenario } from '../../../tracking';
export const SigningPage = () => {
    const [{ signingParams }, dispatch] = useGlobalContext();
    const { requestId } = useParams();
    const history = useHistory();
    useEffect(() => {
        // Resume session if signingParams is not in app state
        if (!signingParams) {
            getSubmittedFormData(requestId).then((result) => {
                if (result.isOk()) {
                    dispatch({
                        type: Action.UPDATE_SIGNING_PARAMS,
                        signingParams: { requestId, signingUrl: result.value.signingUrl },
                    });
                }
                else {
                    remoteLogError(LOGGER_ENDPOINT, new Error(result.error.message)).then(() => {
                        history.push(RoutePath.RAADGIVNING_FATCA);
                    });
                }
            });
        }
    }, [dispatch, signingParams, requestId, history]);
    useEffect(() => {
        trackScenario(scenarioSteps.SIGNING);
    }, []);
    useEffect(() => {
        scroller.scrollTo('bankid-container', {
            duration: 300,
            offset: -100,
            smooth: true,
        });
    }, []);
    if (!signingParams) {
        return React.createElement(SpinnerPage, null);
    }
    return (React.createElement("div", { id: "bankid-container" },
        React.createElement("div", { className: styles.iframe, id: "bankid-iframe", "data-views": "0,view-small|500,view-large" },
            React.createElement("iframe", { src: signingParams.signingUrl, width: "100%", height: "100%", frameBorder: "0" }))));
};
